import React from 'react';
import PropTypes from 'prop-types';
import { ApiFilled, CloseOutlined } from '@ant-design/icons';
import moment from 'moment';
import { Container, Description, DismissButton, IconWrapper } from './apiOriginBanner.styled';

function ApiOriginBanner({ criadoEm, onDismiss }) {
  const formattedDate = criadoEm ? moment(criadoEm).format('DD/MM/YYYY [às] HH:mm') : '';

  return (
    <Container>
      <IconWrapper aria-hidden>
        <ApiFilled />
      </IconWrapper>

      <Description>Requisição aberta via API em {formattedDate}</Description>

      {onDismiss && (
        <DismissButton
          aria-label="Fechar aviso"
          type="button"
          onClick={onDismiss}
        >
          <CloseOutlined />
        </DismissButton>
      )}
    </Container>
  );
}

ApiOriginBanner.propTypes = {
  criadoEm: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.object]),
  onDismiss: PropTypes.func,
};

ApiOriginBanner.defaultProps = {
  criadoEm: undefined,
  onDismiss: undefined,
};

export default ApiOriginBanner;
